<template>
    <div id="orderinfo">
        <van-nav-bar
            title="单据信息"
            left-text="返回"
            right-text="交流信息"
            left-arrow
            @click-left="clickback"
            @click-right="showmsg"/>
        <van-loading vertical v-if="loading"/>
        <van-cell
            :title="order.vip_name + '[' + order.vip_grade + ']'"
            :value="order.state_name"
            value-class="headervalue">
            <div slot="label">
                <div class="van-hairline">电话:{{ order.phone }}</div>
                <div class="van-hairline">微信:{{ order.wechat }}</div>
            </div>
        </van-cell>
        <van-swipe :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="itm in goods" :key="itm.car_products">
                <van-card
                    :price="itm.price - itm.deduction_amount - itm.global_deduction_amount"
                    :desc="itm.version_name"
                    :title="itm.car_products_name"
                    :num="itm.qty"
                    :thumb="itm.img_url"/>
            </van-swipe-item>
        </van-swipe>
        <van-cell title="单据信息">
            <div slot="label">
                <div class="van-hairline"><span class="label">单号:</span>{{ order.bill_no.toLocaleUpperCase() }}</div>
                <div class="van-hairline">下单时间:{{ $moment(order.create).format("YYYY-MM-DD HH:mm") }}</div>
                <div class="van-hairline">取货方式:{{ order.delivery_style_name }}</div>
                <div class="van-hairline">提货日期:{{ order.plan_date }}</div>
                <div class="van-hairline">提货时间:{{ order.plan_time_name }}</div>
                <div class="van-hairline">优惠券:￥{{ order.deduction_amount}}</div>
                <div class="van-hairline">储值卡:￥{{ order.storedvaluecard_amount }}</div>
                <div class="van-hairline">现金:￥{{ order.rev_amount }}</div>
            </div>
        </van-cell>
        <van-cell title="单据进展">
            <van-steps slot="label" direction="vertical">
                <van-step
                    v-for="itm in steps"
                    :key="itm.id">
                    <div class="van-hairline">{{ itm.step_name }}</div>
                    <p>{{ $moment(itm.create_date).format('YYYY-MM-DD HH:mm') }}</p>
                </van-step>
            </van-steps>
        </van-cell>
    </div>
</template>

<script>
import { OrderApi } from '@/api/market'
import { StepMsgApi } from '@/api/message'
import {
    NavBar,
    Swipe,
    SwipeItem,
    Card,
    Panel,
    CellGroup,
    Cell,
    Step,
    Steps,
    Tag,
    // Field,
    // Popup,
    // CouponCell,
    // CouponList,
    // TreeSelect,
    // SubmitBar,
    // Stepper,
    // Toast,
    Loading
} from 'vant'
export default {
    components: {
        // [Tag.name]: Tag,
        // [Col.name]: Col,
        // [Icon.name]: Icon,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Card.name]: Card,
        [Step.name]: Step,
        [Steps.name]: Steps,
        [Tag.name]: Tag,
        // [Collapse.name]: Collapse,
        // [CollapseItem.name]: CollapseItem,
        // [List.name]: List,
        [Panel.name]: Panel,
        [NavBar.name]: NavBar,
        [Loading.name]:Loading,
        // [ActionSheet.name]: ActionSheet,
        // [GoodsAction.name]: GoodsAction,
        // [GoodsActionIcon.name]: GoodsActionIcon,
        // [GoodsActionButton.name]: GoodsActionButton
    },
    data() {
        return {
            id: this.$route.params.id,
            loading: false,
            order: {
                vip_name: '',
                bill_no: '',
                phone:'',
                wechat: '',
                vip_grade: '',
                state_name: '',
                create_date: this.$moment(new Date()).format("YYYY-MM-DD HH:mm"),
                plan_date: '',
                plan_time_name: '',
                delivery_style_name: '',
                deduction_amount: 0,
                storedvaluecard_amount: 0,
                rev_amount: 0
            },
            goods: [],
            steps: []
        }
    },
    mounted() {
        console.log(this.id)
        this.getData()
        this.getStepData()
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            that.axios.get(OrderApi + that.id + '/').then((ret) => {
                that.loading = false
                that.order = ret
                that.goods = ret.shopmarketorderitems
                console.log(ret)
            }).catch(function (error) {
                that.loading = false
                console.log(error)
            })
        },
        getStepData() {
            var that = this
            var params = {
                source_style: 1,
                source_id: this.id
            }
            that.axios.get(StepMsgApi, {params: params}).then((ret) => {
                that.steps = ret.results
                console.log(that.steps)
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/user`)
            }
        },
        showmsg() {
            this.$router.push(`/ordermsg/${this.id}`)
        }
    }
}
</script>

<style lang='less' scoped>
#orderinfo {
    .headervalue {
        color:#ee0a24;
        font-weight: bold;
    }
    .van-cell__label {
        .van-hairline {
            .label {
                width: 200px;
                font-weight: 600;
            }
        }
    }
}
</style>